import React from 'react'
import { Redirect } from 'react-router-dom'
import { inject, observer } from 'mobx-react';
import {
    APP,
    LOGIN,
    DASHBOARD,
    COMPANY_SELECTION,
    PENDING_INVITATIONS,
    WITHHOLDINGS_GENERATION,
    WITHHOLDINGS_DETAIL,
    INVOICES_LIST,
    PROVIDERS_LIST,
    PROVIDERS_EDIT,
    INVOICES_ADD,
    WITHHOLDINGS_LIST,
    REPORTS_PURCHASELEDGER,
    COMPANY_SETTINGS,
    TXT_SECTION,
    TXT_GENERATE,
    SETTINGS,
    INVOICES_EDIT,
    FISCAL_CALENDAR_COMPANY,
    ISLR_RULES,
    LICENSE_PAYMENT
} from 'Constants/Routes'
import Dashboard from 'Pages/Dashboard'
import CompanySelection from 'Pages/Companies/Selection'
import InvoiceRegister from 'Pages/Invoices/Register'
import InvoiceEdit from 'Pages/Invoices/Edit'
import PendingInvitations from 'Pages/PendingInvitations'
import WithholdingGeneration from 'Pages/Withholding/Generation'
import InvoicesList from 'Pages/Invoices/List'
import ProvidersList from 'Pages/Providers/List'
import ProvidersEdit from 'Pages/Providers/Edit'
import WithholdingList from 'Pages/Withholding/List'
import WithholdingDetail from 'Pages/Withholding/Detail'
import PurchaseLedger from 'Pages/Reports/PurchaseLedger'
import CompanySettings from 'Pages/Companies/Settings'
import TxtList from 'Pages/Txt/List'
import TxtGenerate from 'Pages/Txt/List'
import { Route, Switch } from 'react-router-dom'
import LoadingSpinner from './LoadingSpinner'
import SNavbar from 'Components/SNavbar'
import SSidebar from 'Components/SSidebar'
import Settings from 'Pages/Settings'
import FiscalCalendarCompany from 'Pages/FiscalCalendar/Company'
import IslrRulesPage from 'Pages/IslrRules'
import LicensePaymentPage from 'Pages/Licensing/Payment'
import AdminRoute from 'Components/AdminRoute'
import { Container } from 'react-bootstrap'

const AppInside = ({ userStore, uiStore, companyStore, authStore }) => {

    if (authStore.inProgress) {
        return (
            <div className="d-flex justify-content-center align-items-center w-100" style={{ height: '100vh' }}>
                <LoadingSpinner />
            </div>
        )
    }

    if (!userStore.currentUser || !userStore.currentUser.token) {
        return <Redirect to={{ pathname: LOGIN }} />
    }

    if (!companyStore.selectedCompany) {
        return <>
            <Container >
                <Switch>
                    <Route path={COMPANY_SELECTION} component={CompanySelection} />
                    <Route path={PENDING_INVITATIONS} component={PendingInvitations} />
                    <Redirect to={COMPANY_SELECTION} />
                </Switch>
            </Container>
        </>
    }

    return (
        <>
            <div className={"sidebar-controller " + (uiStore.isSidebarVisible ? "active" : "collapsed")}>
                <SNavbar />
                <SSidebar />
                <div className="content-wrapper">
                    <Container >
                        <Switch>
                            <Route exact path={APP} component={Dashboard} />
                            <Route exact path={DASHBOARD} component={Dashboard} />
                            <Route exact path={PENDING_INVITATIONS} component={PendingInvitations} />
                            <Route exact path={INVOICES_LIST} component={InvoicesList} />
                            <Route exact path={INVOICES_ADD} component={InvoiceRegister} />
                            <Route exact path={INVOICES_EDIT} component={InvoiceEdit} />
                            <Route exact path={PROVIDERS_LIST} component={ProvidersList} />
                            <Route exact path={PROVIDERS_EDIT + ':id'} component={ProvidersEdit} />
                            <Route exact path={WITHHOLDINGS_GENERATION} component={WithholdingGeneration} />
                            <Route exact path={WITHHOLDINGS_DETAIL} component={WithholdingDetail} />
                            <Route exact path={WITHHOLDINGS_LIST} component={WithholdingList} />
                            <Route exact path={REPORTS_PURCHASELEDGER} component={PurchaseLedger} />
                            <Route exact path={COMPANY_SETTINGS} component={CompanySettings} />
                            <Route exact path={TXT_SECTION} component={TxtList} />
                            <Route exact path={TXT_GENERATE} component={TxtGenerate} />
                            <Route exact path={TXT_GENERATE} component={TxtGenerate} />
                            <Route exact path={SETTINGS} component={Settings} />
                            <Route exact path={FISCAL_CALENDAR_COMPANY} component={FiscalCalendarCompany} />
                            <Route exact path={LICENSE_PAYMENT} component={LicensePaymentPage} />
                            <AdminRoute exact path={ISLR_RULES} component={IslrRulesPage} />
                            <Redirect to={APP} />
                        </Switch>
                    </Container>
                </div>
            </div>
        </>
    )
}

export default inject("userStore", "uiStore", "companyStore", "authStore")(observer(AppInside))